// ================================
// IMPORTS
// ================================
import { computed } from "vue"
import { useRoute } from "vue-router"

// ================================
// COMPOSABLE
// ================================

/**
 * Détection du mode intégration Homeys en iframe (widget / embed) via `?embed=1`.
 * Aligné sur l’ancien `useEmbed` (contexte « widget data ») : pas de layout shell sur la route racine,
 * communication hauteur → parent via `postMessage` dans {@link App.vue}.
 *
 * @returns isHomeysIframe — true si l’application est chargée en mode iframe widget
 */
export function useHomeysIframe() {
    const route = useRoute()

    const isHomeysIframe = computed(() => route.query.embed === "1")

    return { isHomeysIframe }
}
